// Simple debug logging utility for email debugging
// This will be imported by emailService to log to file

export const debugLog = (message: string, data?: any) => {
  const timestamp = new Date().toISOString();
  const logEntry = `[${timestamp}] ${message}`;
  
  if (data) {
    console.log(logEntry, data);
    // Also write to a file-like structure we can access
    try {
      // Store in localStorage for debugging
      const existingLogs = localStorage.getItem('emailDebugLogs') || '[]';
      const logs = JSON.parse(existingLogs);
      logs.push({ timestamp, message, data });
      // Keep only last 50 entries to avoid localStorage overflow
      if (logs.length > 50) {
        logs.splice(0, logs.length - 50);
      }
      localStorage.setItem('emailDebugLogs', JSON.stringify(logs));
    } catch (e) {
      console.error('Failed to write debug log:', e);
    }
  } else {
    console.log(logEntry);
  }
};

export const getDebugLogs = () => {
  try {
    return JSON.parse(localStorage.getItem('emailDebugLogs') || '[]');
  } catch (e) {
    console.error('Failed to read debug logs:', e);
    return [];
  }
};

export const clearDebugLogs = () => {
  localStorage.removeItem('emailDebugLogs');
};
